module.exports = __webpack_public_path__ + "assets/img/11.c231de8c.png";